import { resolveImagePath } from '@/utils/imageResolver';

export function SanctuarySection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-4">
            Your Sanctuary of
          </h2>
          <h5 className="text-2xl md:text-3xl font-light text-amber-600 italic">
            Safety
          </h5>
        </div>

        <div className="mb-12">
          <img 
            src={resolveImagePath('/images/kintsugi-silhouettes.jpg')} 
            alt="Two artistic silhouettes with golden kintsugi-style cracks, representing healing and transformation" 
            className="w-full max-w-4xl mx-auto rounded-lg shadow-lg"
          />
        </div>

        <div className="max-w-4xl mx-auto text-center space-y-6">
          <p className="text-lg leading-relaxed text-gray-700">
            With me, therapy exceeds the conventional, especially for those navigating moments of crisis. 
            I deeply value the sanctity of your time, privacy, and comfort. My expertise lies in fostering 
            harmonious communication between you and your partner, guiding you both toward deeper understanding 
            and connection during challenging times.
          </p>
          
          <p className="text-lg leading-relaxed text-gray-700">
            Couples therapy is not just a service; it is an investment in the health and future of your 
            relationship. By maintaining a smaller caseload, I offer my clients unparalleled availability, 
            accessibility, and flexibility—qualities often absent in typical therapy practices. While the 
            fee of $750 for a 90-minute session may seem high, many spend that much on weddings, vacations, 
            or homes. But, what is the value of those expenses if your relationship disintegrates?
          </p>
          
          <p className="text-lg leading-relaxed text-gray-700 font-medium">
            So, I ask you: will you actively invest in building a stronger future together, or will you 
            be content to just hope for the best?
          </p>
        </div>
      </div>
    </section>
  );
}